import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CardContent, CardMedia, Typography } from '@mui/material';
import { Videos, ChannelCard } from "./";
import { fetchFromAPI } from "../utils/fetchFromAPI";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import { demoProfilePicture,defaultPicture } from '../utils/constants';
import image from "../imgs/51609512565yazhgbi2hi.png"
import defaultLogo from "../imgs/youtube-square-logo-3F9D037665-seeklogo.com.png"


const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState();
  const [videos, setVideos] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    const fetchResults = async () => {
      const data = await fetchFromAPI(`channels?part=snippet&id=${id}`);

      setChannelDetail(data?.items[0]);

      const videosData = await fetchFromAPI(`search?channelId=${id}&part=snippet%2Cid&order=date`);

      setVideos(videosData?.items);
    };

    fetchResults();
  }, [id]);

  return (
    <Box sx={{ overflowY: "auto", flex: 2, height: "80vh" }}>
      <Box sx={{ backgroundImage:`url(${image})`,backgroundRepeat:"no-repeat" ,backgroundSize:"100%"}}>
        <div style={{
          position:"relative",
          height:'300px',
          zIndex: 10,
         
          // background: 'linear-gradient(90deg, rgba(0,238,247,1) 0%, rgba(206,3,184,1) 100%, rgba(0,212,255,1) 100%)',
        }} />


        <Box
          sx={{
            boxShadow: 'none',
            borderRadius: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: { xs: '356px', md: '320px' },
            height: '326px',
            margin: 'auto',
            marginTop:"-93px",
          }}
        >
        {/* <Link to={`/channel/${channelDetail?.id?.channelId}`}> */}
          <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', color: '#fff' }}>
            <CardMedia
              image={defaultLogo}
              alt={channelDetail?.snippet?.title}
              sx={{ borderRadius: '50%', height: '180px', width: '180px', mb: 2, border: '1px solid #e3e3e3' }}
            />
            <Typography variant="h6">
              {channelDetail?.snippet?.title}{' '}
              <CheckCircleIcon sx={{ fontSize: '14px', color: 'gray', ml: '5px' }} />
            </Typography>
            {channelDetail?.statistics?.subscriberCount && (
              <Typography sx={{ fontSize: '15px', fontWeight: 500, color: 'gray' }}>
                {parseInt(channelDetail?.statistics?.subscriberCount).toLocaleString('en-US')} Subscribers
              </Typography>
            )}
          </CardContent>
        {/* </Link> */}
      </Box>



      </Box>
      <Box p={2} display="flex" alignItems="center" justifyContent="center">
      <Box sx={{ mr: { sm: '100px' } }}/>
        <Videos  videos={videos}/>
      </Box>
    </Box>
  );
};

export default ChannelDetail;